import {
  InsightScheduleCreateRequest,
  InsightScheduleUpdateRequest
} from '@futrli-sdk/predict';

import {
  createSchedule,
  updateSchedule,
  deleteSchedule,
  deleteAllSchedules
} from '../../predict/src/core/api/business-insights-schedule';

import { createMutation } from '../utils/mutations';
import { schedulesQueryKey } from '../queries/schedules';
import { queryClient } from '../core/queryClient';

type CreateScheduleResult = Awaited<ReturnType<typeof createSchedule>>;
type UpdateScheduleResult = Awaited<ReturnType<typeof updateSchedule>>;
type DeleteScheduleResult = Awaited<ReturnType<typeof deleteSchedule>>;
type DeleteAllSchedulesResult = Awaited<ReturnType<typeof deleteAllSchedules>>;

export const createScheduleMutation = (workspaceId: string, organisationId: string) =>
  createMutation<Partial<InsightScheduleCreateRequest>, CreateScheduleResult>({
    mutationFn: data => createSchedule(workspaceId, organisationId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: schedulesQueryKey(organisationId, workspaceId) });
    }
  });

export const updateScheduleMutation = (workspaceId: string, organisationId: string) =>
  createMutation<{ scheduleId: string; data: Partial<InsightScheduleUpdateRequest> }, UpdateScheduleResult>({
    mutationFn: input => updateSchedule(workspaceId, organisationId, input.scheduleId, input.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: schedulesQueryKey(organisationId, workspaceId) });
    }
  });

export const deleteScheduleMutation = (workspaceId: string, organisationId: string) =>
  createMutation<string, DeleteScheduleResult>({
    mutationFn: scheduleId => deleteSchedule(workspaceId, organisationId, scheduleId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: schedulesQueryKey(organisationId, workspaceId) });
    }
  });

export const deleteAllSchedulesMutation = (workspaceId: string, organisationId: string) =>
  createMutation<void, DeleteAllSchedulesResult>({
    mutationFn: () => deleteAllSchedules(workspaceId, organisationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: schedulesQueryKey(organisationId, workspaceId) });
    }
  });
